import { createReducer, createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	getUserRequest: null,
	getUserSuccess: ["user"],
	getUserFailure: null,
});

export const UserTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	user: null,
	loading: false,
};

/* ------------- Reducers ------------- */

// request the data from an api
export const getUserRequest = state => Object.assign({}, state, { loading: true });
export const getUserSuccess = (state, { user }) => (
	Object.assign({}, state, { user, loading: false })
);
export const getUserFailure = state => Object.assign({}, state, { loading: false });


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_USER_REQUEST]: getUserRequest,
	[Types.GET_USER_SUCCESS]: getUserSuccess,
	[Types.GET_USER_FAILURE]: getUserFailure,
});



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js